import InstagramIcon from "Component/InstagramIcon";
import React from "react";
import FacebookIcon from "Component/FacebookIcon";
import TwitterIcon from "Component/TwitterIcon";
import PintrestIcon from "Component/PintrestIcon";
import YoutubeIcon from "Component/YoutubeIcon";
import companyCred from "Src/Value/companyCred.json";
import LinkedInIcon from "Component/LinkedInIcon";

export const RENDER_NEWSLETTER = 'render_newsletter';

export const NEWSLETTER_COLUMN = {
    title: 'Newsletter',
    columnActiveKey: 'newsletterActive',
    items: [
        {
            render: RENDER_NEWSLETTER,
        },
    ],
};

export const COLUMN_MAP = [
    {
        title: 'CLIENT CARE',
        items: [
            {
                href: '/lifetime-warranty',
                title: 'Lifetime Warranty',
            },
            {
                href: '/free-shipping',
                title: 'Free Shipping',
            },
            {
                href: '/returns',
                title: 'Free Return',
            },
            {
                href: '/sales/guest/form/',
                title: 'Order Track',
            },
            {
                href: '/payment-options',
                title: 'Payment Options'
            },
            {
                href: '/diamond-upgrade',
                title: 'Diamond Upgrade',
            },
            {
                href: '/synchrony-financing-option',
                title: `${companyCred?.comapnyName} Credit Card`,
            },
            // {
            //     href: '/snap-financing-option',
            //     title: 'Snap Financing'
            // }
        ],
    },
    {
        title: 'ABOUT US',
        items: [
            {
                href: '/about',
                title: 'Our Story',
            },
            {
                href: '/frequently-asked-question',
                title: 'FAQ',
            },
            {
                href: '/privacy-policy',
                title: 'Privacy Policy',
            },
        ],
    },
    {
        title: 'EDUCATION',
        items: [
            {
                href: '/blogs',
                title: 'Blog',
            },
            {
                href: '/natural-diamond',
                title: 'Diamond Guide',
            },
            {
                href: '/lab-created',
                title: 'Lab Grown Diamonds',
            },
            {
                href: '/conflict',
                title: 'Conflict Free Diamonds',
            },
        ],
    },
    {
        title: 'CONTACT',
        items: [
            {
                href: '/contact',
                title: 'Contact Us',
            },
            {
                href: `tel:${companyCred?.mobileNumber}`,
                title: companyCred?.mobileNumber,
                label: "Call Now : "
            },
            {
                href: `mailto:${companyCred?.email}`,
                title: companyCred?.email,
                label: "Email Us : "
            },
            {
                href: '#',
                title: companyCred?.address,
                label: "Head Office : "
            },
        ],
    },
];

export const FOLLOW_LINKS = [
    {
        title: 'Follow',
        isItemsHorizontal: true,
        items: [
            {
                href: companyCred?.instagram,
                src: <InstagramIcon />,
                title: 'Instagram',
            },
            {
                href: companyCred?.twitter,
                src: <TwitterIcon />,
                title: 'Twitter',
            },
            {
                href: companyCred?.facebook,
                src: <FacebookIcon />,
                title: 'Facebook',
            },
            {
                href: companyCred?.youtube,
                src: <YoutubeIcon />,
                title: 'YouTube',
            },
            {
                href: companyCred?.linkedIn,
                src: <LinkedInIcon />,
                title: 'LinkedIn',
            },
            {
                href: companyCred?.pinterest,
                src: <PintrestIcon />,
                title: 'Pintrest',
            },
        ],
    },
];
